<template lang="pug">
    div
        v-btn(
            v-if="filters && filters.length > 0"
            round 
            :color="colors.primary" 
            dark
            @click="show = !show"
        )
            span Filtros
        div(v-if="show")
            v-layout(row wrap)
                template(v-for="filter in filters")
                    v-flex.xs12.md6.px-3(:key="filter.field")
                        v-text-field(
                            v-if="!filter.options"
                            :label="filter.label"
                            v-model="vmodels[filter.field]"
                        )
                        v-select(
                            v-if="filter.options && filter.options.length > 0"
                            v-model="vmodels[filter.field]"
                            :items="filter.options"
                            multiple
                            :label="filter.label"
                            chips
                        )
                v-flex.px-3.xs12(:class="{md6: filters.length % 2 != 0}")
                    v-btn(block :color="colors.primary" dark large @click="applyFilter()") Filtrar
</template>

<script>
import { objectIsEmpty } from '@/services/JSUtils.js'
export default {
    name: 'data-table-filters',
    props: {
        /**
         * @description
         * Filters to be showed
         */
        filters: {
            type: Array,
            default: () => [],
        },
    },
    data: function() {
        return {
            show: false,
            vmodels: {},
        }
    },
    computed: {},
    methods: {
        setVmodels: function() {
            let vmodels = {}
            this.filters.forEach(filter => {
                vmodels[filter.field] = filter.value
            })
            this.vmodels = JSON.parse(JSON.stringify(vmodels))
        },
        applyFilter: function(){
            let vmodels = JSON.parse(JSON.stringify(this.vmodels))
            const filters = []
            for(const key in vmodels){
                if(vmodels.hasOwnProperty(key)){
                    let val = vmodels[key]
                    if(typeof(val) === 'string'){
                        val = val.trim()
                        if(val != ''){
                            val = [val]
                            let filter = {}
                            filter.field = key,
                            filter.value = val
                            filters.push(filter)
                        } 
                    }else if(val.constructor === Array && val.length > 0){
                        let filter = {}
                        filter.field = key
                        filter.value = val
                        filters.push(filter)
                    }
                }
            }
            this.$emit('filter', filters)
        }
    },
    watch: {
        /**
         * @description
         * Listen to filters changes to
         */
        filters: {
            handler: function() {
                if(!objectIsEmpty(this.vmodels)) return
                this.setVmodels()
            },
            deep: true,
        },
    },
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>